export default function filterContent(content) {
    const brandMarketingConsentItem = []
    const otherBrandsConsentItems = []
    const footerItem = []
    const successItem = []

    content?.items.forEach((item) => {
        if (item.type === 'ynapteaser') {
            if (item.layoutVariant === 'consent-title') {
                brandMarketingConsentItem.push(item)
            }
            if (item.layoutVariant === 'consent-footer') {
                footerItem.push(item)
            }
            if (item.layoutVariant === 'consent-success') {
                successItem.push(item)
            }
            return
        }

        const itemKey = item.items?.find((child) => child.layoutVariant === 'consent-checkbox').ID

        if (itemKey === 'maMarketingConsent') {
            brandMarketingConsentItem.push(item)
        } else {
            otherBrandsConsentItems.push(item)
        }
    })

    return {
        brandMarketingConsentItem,
        otherBrandsConsentItems,
        footerItem,
        successItem,
    }
}
